import type { CdbInputTableConfiguration } from "./cdbInputTables";
import { getCdbInputTableData } from "./cdbInputTables";
import type { DimensionDataSourceConfiguration } from "./dimensions";
import { getDimensions } from "./dimensions";
import type { FixedDataTableConfiguration } from "./fixedData";
import { getFixedData } from "./fixedData";
import type { RequestParameterDataSourceConfiguration } from "./requestParameters";
import { getRequestParameters } from "./requestParameters";

export enum DataSource {
    CDB_INPUT_TABLE = "cdb_input_table",
    FIXED_DATA = "fixed_data",
    DIMENSIONS = "dimensions",
    REQUEST_PARAMETER = "request_parameters",
}

export interface BaseDataSourceConfiguration {
    type: DataSource;
    settings?: any;
    optionalDependencies?: boolean;
    requirements?: string[];
}

export type DataSourceConfiguration =
    | CdbInputTableConfiguration
    | FixedDataTableConfiguration
    | DimensionDataSourceConfiguration
    | RequestParameterDataSourceConfiguration;

export const DataSourceGetterMap: {
    [key in DataSource]: (...args: any[]) => Promise<any>;
} = {
    [DataSource.CDB_INPUT_TABLE]: getCdbInputTableData,
    [DataSource.FIXED_DATA]: getFixedData,
    [DataSource.DIMENSIONS]: getDimensions,
    [DataSource.REQUEST_PARAMETER]: getRequestParameters,
};
